import React from 'react'

import {useUserName} from './use-user-name'
import {UserNameBase} from './user-name-base'
import {UserNameProps} from './types'

export const UserName = ({
  user,
  userId,
  guestId,
  nameOverride,
  task,
  context,
  className
}: UserNameProps) => {
  const {name, type} = useUserName({user, userId, guestId, nameOverride, task})
  return (
    <UserNameBase
      name={name}
      type={type}
      context={context}
      className={className}
    />
  )
}
